export default __webpack_public_path__ + "static/media/mukul.9271f820.png";